// frontend/src/components/Layout/index.jsx

import React from 'react';
import { Outlet, useLocation, Link, useNavigate } from 'react-router-dom';
import backgroundImage from '../../assets/background.png';
import BackButton from '../common/BackButton';
import useAuth from '../../hooks/useAuth';
import './index.css'; 

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, isAuthenticated, logout } = useAuth();

  const hideBackButtonExactPaths = [
    '/',
    '/login',
    '/register',
    '/recuperar-senha',
    '/dashboard'
  ];

  const hideBackButtonWildcardPatterns = [
    '/partida/*/sumula'
  ];

  const shouldHideBackButton = () => {
    if (hideBackButtonExactPaths.includes(location.pathname)) {
      return true;
    }
    return hideBackButtonWildcardPatterns.some(pattern => {
      const regexPattern = pattern.replace(/\*/g, '[^/]+');
      return new RegExp(`^${regexPattern}$`).test(location.pathname);
    });
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const style = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    minHeight: '100vh',
  };

  return (
    <div className="app-container" style={style}>
      
      {/* ✅ ESTA É A BARRA QUE APARECERÁ PARA TODOS OS USUÁRIOS LOGADOS */}
      {isAuthenticated && (
        <header className="main-header">
          <div className="header-user-info">
            <span>Olá, <strong>{user.name?.split(' ')[0]}</strong>!</span>
            {user.role === 'Admin' && <span className="user-role-badge admin">Admin</span>}
            {user.role === 'Gestor' && <span className="user-role-badge gestor">Gestor</span>}
          </div>
          <nav className="header-nav">
            { (user.role === 'Admin' || user.role === 'Gestor') && <Link to="/dashboard">Dashboard</Link> }
            <Link to="/profile">Meu Perfil</Link>
            <button onClick={handleLogout} className="logout-button">Sair</button>
          </nav>
        </header>
      )}

      {!shouldHideBackButton() && <BackButton />}

      <main>
        <Outlet />
      </main>
    </div>
  );
}